<app-card-widget [title]="widgetTitle" subtitle="{{endCustomer?.name}}">

  <form [formGroup]="form" id="end-customer-form" (ngSubmit)="save()" novalidate>

    <div class="card-section-container">

      <div class="card-section">

        <app-end-customer-auto-complete *ngIf="edited && selectingEndCustomer" field="name"
                                        (selected)="endCustomerSelected($event)"></app-end-customer-auto-complete>

        <mat-card-actions *ngIf="edited" align="end">
          <button type="button" mat-icon-button (click)="selectEndCustomer()" title="Search for existing End Customer">
            <mat-icon>search</mat-icon>
          </button>
          <!-- Adding an end customer needs end-customers:create (issue #533). -->
          <ng-container *ngIf="{ allowed: canCreateEndCustomer$ | async } as createGate">
            <app-permission-gate class="add-end-customer-action" [allowed]="createGate.allowed" [permission]="createPermission">
              <button type="button" mat-icon-button (click)="createEndCustomer()" title="Add End Customer"
                      [disabled]="createGate.allowed !== true">
                <mat-icon>add</mat-icon>
              </button>
            </app-permission-gate>
          </ng-container>
        </mat-card-actions>

      </div>

    </div>

    <ng-container formGroupName="endCustomer">
      <div class="card-section-container" *ngIf="edited && isCreating">
        <div class="card-section">
          <mat-form-field>
            <input matInput placeholder="Business ID" formControlName="business_id" (blur)="trimBusinessId()"/>
          </mat-form-field>
          <mat-form-field>
            <mat-select placeholder="Country" formControlName="country">
              <mat-option *ngFor="let option of countryOptions" [value]="option.code">
                {{option.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="card-section-container" *ngIf="!isCreating">
        <div class="card-section">

        <app-text label="Name" *ngIf="!edited">{{endCustomer?.name}}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="Name" formControlName="name"/>
        </mat-form-field>

        <app-text label="Department" *ngIf="!edited">{{endCustomer?.department}}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="Department" formControlName="department"/>
        </mat-form-field>

        <app-text label="Business ID" *ngIf="!edited">{{endCustomer?.business_id}}</app-text>

        <!-- business_id is immutable after creation; read-only in edit mode. -->
        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="Business ID" formControlName="business_id" readonly/>
        </mat-form-field>

        <app-text label="VAT Number" *ngIf="!edited">{{endCustomer?.vat_number}}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="VAT Number" formControlName="vat_number"/>
        </mat-form-field>

        <app-company-form-fields [formGroup]="form.get('endCustomer')" [entity]="endCustomer" [editMode]="edited"></app-company-form-fields>

        <app-text label="Company Situation" *ngIf="!edited">
          <ng-container *ngIf="endCustomer?.company_situation; else noSituation">
            {{endCustomer?.company_situation}} <mat-icon color="warn" style="vertical-align: text-bottom;">warning</mat-icon>
          </ng-container>
          <ng-template #noSituation>-</ng-template>
        </app-text>

        <app-text label="Credit Limit" *ngIf="!edited">{{endCustomer?.credit_limit?.limit.amount | currency:'EUR' }}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer" formGroupName="credit_limit" >
          <ng-container formGroupName="limit">
            <input matInput placeholder="Credit Limit"  formControlName="amount"/>
          </ng-container>
        </mat-form-field>

        <app-text label="Credit Limit Updated">{{(endCustomer?.credit_limit?.checked_at | date:'shortDate') || 'Never'}}
        </app-text>

        <app-text label="Credit Rating" *ngIf="!edited">{{ endCustomer?.aaa_rating?.category }}</app-text>
        <mat-form-field *ngIf="edited" formGroupName="aaa_rating">
          <mat-select placeholder="Rating" formControlName="category">
            <mat-option *ngFor="let rating of aaaRatings" [value]="rating">
              {{rating}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Credit Rating Updated">{{ (endCustomer?.aaa_rating?.checked_at | date:'shortDate') || 'Never'}}
        </app-text>

        <app-text *ngIf="!edited && endCustomer && (endCustomer.credit_limit?.checked_at || endCustomer.aaa_rating?.checked_at)" label="Update Credit Limit And Rating">Mark checked
          <!-- Saves through PUT /end-customers/{id}: needs end-customers:edit (issue #620), gated as Add End Customer is. -->
          <ng-container *ngIf="{ allowed: canEditEndCustomer$ | async } as editGate">
            <app-permission-gate class="touch-credit-check-action" [allowed]="editGate.allowed" [permission]="editPermission">
              <app-hold-to-confirm-button (confirmed)="touchCreditLimitAndRating(endCustomer)" title="Hold to update timestamp"
                                          [disabled]="editGate.allowed !== true"></app-hold-to-confirm-button>
            </app-permission-gate>
          </ng-container>
        </app-text>

        <!--
        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput [matDatepicker]="limitUpdatedPicker" placeholder="Credit Limit Updated" formControlName="credit_limit_updated_at" />
          <mat-datepicker-toggle matSuffix [for]="limitUpdatedPicker"></mat-datepicker-toggle>
          <mat-datepicker #limitUpdatedPicker></mat-datepicker>
        </mat-form-field>

        -->

        </div>

        <div class="card-section">

        <app-text label="Street" *ngIf="!edited">{{endCustomer?.street}}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="Street" formControlName="street"/>
        </mat-form-field>

        <app-text label="Zip" *ngIf="!edited">{{endCustomer?.zip}}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="Zip" formControlName="zip"/>
        </mat-form-field>

        <app-text label="City" *ngIf="!edited">{{endCustomer?.city}}</app-text>

        <mat-form-field *ngIf="edited && !selectingEndCustomer">
          <input matInput placeholder="City" formControlName="city"/>
        </mat-form-field>

        <app-text label="Country" *ngIf="!edited">{{countryName(endCustomer?.country)}}</app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Country" formControlName="country">
            <mat-option *ngFor="let option of countryOptions" [value]="option.code">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-card-actions *ngIf="edited" align="end">
          <button type="button" mat-icon-button (click)="lookupCompany()" title="Lookup from YTJ">
            <mat-icon>search</mat-icon>
          </button>
        </mat-card-actions>

        <!--
          E-invoice delivery routing (design: redesign-einvoice-address-picker).
          Ambient, status-first, card-based picker. The whole sub-group is a
          non-blocking side-channel — the surrounding form stays editable and
          saveable in every lookup state (Decision 1).
        -->
        <div class="einvoice-section" formGroupName="einvoice_address">

          <div class="einvoice-header">
            <span class="einvoice-header__label">E-invoice</span>
            <ng-container [ngSwitch]="einvoiceFreshness">
              <span *ngSwitchCase="'registered'" class="einvoice-badge einvoice-badge--registered">
                <mat-icon>check_circle</mat-icon> registered
              </span>
              <span *ngSwitchCase="'not_registered'" class="einvoice-badge einvoice-badge--stale">
                <mat-icon>warning</mat-icon> not registered
              </span>
              <span *ngSwitchCase="'unverified'" class="einvoice-badge einvoice-badge--unverified">
                <mat-icon>cloud_off</mat-icon> couldn't verify
              </span>
              <span *ngSwitchCase="'loading'" class="einvoice-badge einvoice-badge--loading">
                <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner> checking…
              </span>
            </ng-container>
          </div>

          <!-- VIEW MODE: stored routing + freshness badge, retry when unverified -->
          <ng-container *ngIf="!edited">
            <div class="einvoice-view" *ngIf="hasStoredEinvoiceRouting(); else einvoiceNotSet">
              <!-- The stored routing, both halves read off the stored end customer.
                   The Apix operator code follows as a parenthetical only when it
                   differs from the stored välittäjätunnus, so the majority case
                   renders unchanged and the stored value always leads. -->
              <span class="einvoice-view__routing">{{ einvoiceOperatorDisplay()
                }}<ng-container *ngIf="einvoiceOperatorCodeAnnotation() as code"> ({{ code }})</ng-container> · {{ endCustomer?.einvoice_address?.address }}</span>
              <button type="button" mat-button class="einvoice-retry"
                      *ngIf="einvoiceFreshness === 'unverified'" (click)="retryEinvoiceLookup()">
                <mat-icon>refresh</mat-icon> Retry
              </button>
            </div>
            <ng-template #einvoiceNotSet>
              <div class="einvoice-view einvoice-view--muted">not set</div>
            </ng-template>
          </ng-container>

          <!-- EDIT MODE -->
          <ng-container *ngIf="edited && !selectingEndCustomer">

            <div class="einvoice-loading" *ngIf="einvoiceLookupState === 'loading'">
              Checking addresses with Apix…
            </div>

            <!-- Stored routing answered absent by Apix (stale advisory). The
                 advisory names the *stored* routing (as the view line does, and
                 as the verdict judged), never the live form value (round-5 finding 1). -->
            <div class="einvoice-note einvoice-note--stale" *ngIf="einvoiceFreshness === 'not_registered'">
              <mat-icon color="warn">warning</mat-icon>
              <span>Saved routing {{ endCustomer?.einvoice_address?.address }} ({{ einvoiceOperatorDisplay() }}) is no longer registered with Apix. Pick a current address:</span>
            </div>

            <!-- Apix unreachable (fail open) -->
            <div class="einvoice-note einvoice-note--unverified" *ngIf="einvoiceFreshness === 'unverified'">
              <mat-icon>cloud_off</mat-icon>
              <span>Couldn't reach Apix to check addresses.
                {{ hasStoredEinvoiceRouting() ? 'Showing the saved routing.' : 'Enter the routing manually or retry.' }}</span>
            </div>

            <!-- Candidate cards -->
            <mat-radio-group *ngIf="einvoiceAddressChoices.length > 0" class="einvoice-cards"
                             [value]="selectedEinvoiceCard" (change)="einvoiceCardSelected($event.value)">
              <mat-radio-button *ngFor="let c of einvoiceAddressChoices" class="einvoice-card"
                                [value]="c" [class.einvoice-card--selected]="c === selectedEinvoiceCard">
                <!-- Label: the recognisable Apix operator code (PAGERO), falling
                     back to the välittäjätunnus when Apix returns no code.
                     Ids line: the routing actually stored (välittäjätunnus · address). -->
                <span class="einvoice-card__name">
                  {{ c.operator_id || c.operator }}
                  <span class="einvoice-card__marker" *ngIf="c.matches_stored">
                    <mat-icon>check_circle</mat-icon> saved
                  </span>
                </span>
                <span class="einvoice-card__ids">{{ c.operator }} · {{ c.address }}</span>
                <span class="einvoice-card__hint" *ngIf="einvoiceAddressChoices.length === 1">Only address on file.</span>
              </mat-radio-button>
            </mat-radio-group>

            <!-- Manual routing fields (opt-in, or auto-revealed when trapped) -->
            <div class="einvoice-manual" *ngIf="einvoiceManualFieldsShown">
              <span class="einvoice-manual__label" *ngIf="!einvoiceManualAutoRevealed">Manual routing</span>
              <mat-form-field>
                <input matInput placeholder="Operator (id)" formControlName="operator" />
              </mat-form-field>
              <mat-form-field>
                <input matInput placeholder="Address" formControlName="address" />
              </mat-form-field>
            </div>

            <div class="einvoice-actions">
              <button type="button" mat-button (click)="retryEinvoiceLookup()">
                <mat-icon>refresh</mat-icon> {{ einvoiceLookupState === 'failed' ? 'Retry' : 'Re-check' }}
              </button>
              <button type="button" mat-button *ngIf="!einvoiceManualAutoRevealed" (click)="toggleEinvoiceManualEntry()">
                <mat-icon>{{ einvoiceManualEntry ? 'expand_less' : 'edit' }}</mat-icon>
                {{ einvoiceManualEntry ? 'Hide manual' : 'Edit manually' }}
              </button>
            </div>

          </ng-container>
        </div>

        </div>
      </div>
    </ng-container>

    <div class="card-section-container" *ngIf="!isCreating">
      <div class="card-section" *ngIf="endCustomerContact && endCustomerContacts" formGroupName="contact">

        <mat-form-field *ngIf="edited">
          <mat-select [value]="endCustomerContact" placeholder="Contact" (selectionChange)="endCustomerContactChanged($event)"
                      [disabled]="!form.valid">
            <mat-option *ngFor="let c of endCustomerContacts" [value]="c">
              <span *ngIf="c.id">{{ c.name }} ({{ c.id }})</span>
              <span *ngIf="!c.id">(New)</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Name" *ngIf="!edited">{{endCustomerContact.name}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Name" formControlName="name"/>
        </mat-form-field>

        <app-text label="Email" *ngIf="!edited">{{endCustomerContact.email}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Email" type="email" formControlName="email"/>
        </mat-form-field>

        <app-text label="Phone" *ngIf="!edited">{{endCustomerContact.phone}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Phone" formControlName="phone"/>
        </mat-form-field>

        <mat-card-actions *ngIf="edited" align="end">
          <button type="button" mat-icon-button (click)="removeEndCustomerContact()" [disabled]="!endCustomerContact || (endCustomerContacts?.length <= 1 && !!endCustomerContact.id)"
                  title="Remove Contact">
            <mat-icon>remove</mat-icon>
          </button>
          <button type="button" mat-icon-button (click)="createEndCustomerContact()" [disabled]="!form.valid"
                  title="Add Contact">
            <mat-icon>add</mat-icon>
          </button>
        </mat-card-actions>

      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked" (click)="edit()">Edit</button>
    <button type="button" mat-button *ngIf="edited && isCreating" (click)="createEndCustomerFromBusinessId()" [disabled]="form.get('endCustomer.business_id').invalid || form.get('endCustomer.country').invalid">Continue</button>
    <!--
      Save sends PUT /end-customers/{id} first, which needs end-customers:edit
      (issue #620), so it is gated as Add End Customer is.
    -->
    <ng-container *ngIf="edited && !isCreating">
      <ng-container *ngIf="{ allowed: canEditEndCustomer$ | async } as editGate">
        <app-permission-gate class="save-end-customer-action" [allowed]="editGate.allowed" [permission]="editPermission">
          <button type="submit" mat-button [disabled]="(!form.valid && !selectingEndCustomer) || editGate.allowed !== true"
                  form="end-customer-form">Save
          </button>
        </app-permission-gate>
      </ng-container>
    </ng-container>
    <button type="reset" mat-button *ngIf="edited" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>
